import styles from './StreamingCaret.module.css';

export function StreamingCaret() {
  return <span className={styles.caret} aria-hidden data-chat-caret="" />;
}

export const streamingMarkdownClassName = styles.streaming;
